interface Props {
  data: {
    code: string;
    name: string;
    flag: string;
  };
}

const TimezoneFormat: React.FC<Props> = ({ data: { name, flag } }) => {
  return (
    <div className="flex items-center">
      <img src={`/assets/img/flags/${flag}`} alt={name} className="w-5 h-3.5 mr-2" />
      <span>{name}</span>
    </div>
  );
};

export default TimezoneFormat;
